var mapStyles = [
  {
	"elementType": "labels",
	"stylers": [
	  {
		"visibility": "off"
	  }
	]
  },
  {
	"featureType": "administrative",
	"elementType": "geometry",
	"stylers": [
	  {
		"visibility": "off"
	  }
	]
  },
  {
	"featureType": "administrative.country",
	"elementType": "geometry.stroke",
	"stylers": [
	  {
		"color": "#003F6D"
	  },
	  {
		"visibility": "on"
	  },
	  {
		"weight": 2
	  }
	]
  },
  {
	"featureType": "administrative.land_parcel",
	"stylers": [
	  {
		"visibility": "off"
	  }
	]
  },
  {
	"featureType": "administrative.locality",
	"elementType": "geometry.stroke",
	"stylers": [
	  {
		"color": "#003F6D"
	  },
	  {
		"visibility": "off"
	  },
	  {
		"weight": 4.5
	  }
	]
  },
  {
	"featureType": "administrative.neighborhood",
	"stylers": [
	  {
		"visibility": "off"
	  }
	]
  },
  {
	"featureType": "administrative.neighborhood",
	"elementType": "geometry.stroke",
	"stylers": [
	  {
		"color": "#003F6D"
	  },
	  {
		"weight": 3.5
	  }
	]
  },
  {
	"featureType": "administrative.province",
	"elementType": "geometry.stroke",
	"stylers": [
	  {
		"color": "#003F6D"
	  },
	  {
		"visibility": "on"
	  },
	  {
		"weight": 2.5
	  }
	]
  },
  {
	"featureType": "landscape",
	"elementType": "geometry.fill",
	"stylers": [
	  {
		"color": "#0068EE"
	  }
	]
  },
  {
	"featureType": "landscape",
	"elementType": "geometry.stroke",
	"stylers": [
	  {
		"color": "#003F6D"
	  },
	  {
		"visibility": "on"
	  },
	  {
		"weight": 3
	  }
	]
  },
  {
	"featureType": "poi",
	"stylers": [
	  {
		"visibility": "off"
	  }
	]
  },
  {
	"featureType": "road",
	"stylers": [
	  {
		"visibility": "off"
	  }
	]
  },
  {
	"featureType": "road",
	"elementType": "labels.icon",
	"stylers": [
	  {
		"visibility": "off"
	  }
	]
  },
  {
	"featureType": "transit",
	"stylers": [
	  {
		"visibility": "off"
	  }
	]
  }
];

window.mapStyles = mapStyles;
